import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Formik } from "formik";
import * as yup from "yup";

const initialValues = {
  period: "",
};
const onFormSubmit = async (values) => {
 
};
const validatePeriodForm = yup.object().shape({
  period: yup.number().required("Period is required"),
});
export default function DialogPrice({
  openprice,
  onChangeAddReferal,
  closeprice,
  referal_amount,
  updateonReferalAmount,
}) {
  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => onFormSubmit(values)}
        validationSchema={validatePeriodForm}
      >
        {({ handleBlur }) => (
          <>
            <Dialog
              open={openprice}
              onClose={closeprice}
              aria-labelledby="responsive-dialog-title"
            >
              <DialogContent>
                <DialogTitle
                  sx={{
                    fontWeight: "400",
                    fontSize: "16px",
                    lineHeight: "19px",
                    color: "#1A1A1A",
                    padding: "18px 2px",
                  }}
                >
                  Update Referral Amount
                </DialogTitle>
                <DialogContentText marginTop="-15px">
                  <input
                    placeholder="Referral amount"
                    style={{
                      padding: "10px 15px",
                      width: "300px",
                      height: "25px",
                      background: "#FFFFFF",
                      border: "1px solid #EBEBEB",
                      borderRadius: "6px",
                      marginTop: "10px",
                    }}
                    onBlur={handleBlur("period")}
                    onChange={(e) =>
                      onChangeAddReferal("referal_amount", e.target.value)
                    }
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^0-9]/g, "")
                        .slice(0, 3);
                    }}
                    defaultValue={referal_amount}
                  ></input>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  sx={{
                    background: "#04AAD",
                    marginRight: "1rem",
                    width: "100.17px",
                    height: "40px",
                    marginBottom: "1.2rem",
                    cursor: "pointer",
                  }}
                  disabled={!referal_amount}
                  onClick={() => {
                    updateonReferalAmount();
                  }}
                >
                  UPDATE
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
      </Formik>
    </>
  );
}
